import { IRootState } from '../../../../store'
import { IDrainState } from '../store/drain.types'

export const getDrainSelector = (state: IRootState): IDrainState => state.drain
